import React from 'react';
import MuiDrawer from '@mui/material/Drawer';
import {Button, TextField} from '@mui/material';
import styled from 'styled-components';
import {Close} from '@mui/icons-material'
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';


const StyledDrawer = styled(MuiDrawer).withConfig({ shouldForwardProp: (prop) => prop !== 'open' })<{open: boolean;}>`
  height: 100%;
  width: ${p => p.open ? 'auto' : `0`};
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1200;

  .MuiDrawer-paper {
    position: relative;
    transition: width 0.5s ease;
  }

  ${p => p.open && `
    &::before {
      content: '';
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background-color: rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(2px);
      z-index: -1;
    }
  `}
`;
interface ChapterResultDrawerProps {
    result: string;
    open: boolean;
    close: (updatedName?: string) => void;
    updateResultDrawer: (chapterId: string, newName: string) => void;
    selectedChapterId: string;
}
const ChapterResultDrawer: React.FC<ChapterResultDrawerProps>  = ({result, open, close, updateResultDrawer, selectedChapterId}) => {

    const validationSchema = Yup.object().shape({
        chapterResult: Yup.string()
            .trim(' ')
            .min(3, 'Минимальная длина названия курса - 3 символа')
            .matches(/.*[a-zA-Zа-яА-Я]+.*/, 'Название курса должно содержать хотя бы одну букву')
            .required('Необходимо ввести результат')
            .max(1000, 'Результат должен быть не более 1000 символов'),
    });
    return(
        <StyledDrawer variant="permanent"
                      anchor="right"
                      open={open}
        >
            <div className="chapter-drawer-close" onClick={() => close()}><Close/></div>
            <div className="chapter-drawer-content">
                <div className="constructor-content-title">
                    Добавить результат раздела
                </div>
                <div className="corse-content-description">
                    Опишите результат по итогу раздела для ваших студентов: что узнают, какие навыки получат, чему научатся и так далее.
                </div>
                <Formik
                    initialValues={{ chapterResult: result }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                        updateResultDrawer(selectedChapterId, values.chapterResult);
                        close();
                    }}
                >
                    {({ errors, touched, values }) => (
                        <Form>
                                <Field
                                    as={TextField}
                                    variant="outlined"
                                    placeholder="Введите результат"
                                    name="chapterResult"
                                    error={Boolean(errors.chapterResult && touched.chapterResult)}
                                    helperText={(errors.chapterResult && touched.chapterResult) && errors.chapterResult}
                                    className="without-label"
                                    fullWidth
                                />
                            <div className={values.chapterResult.length > 1000 ? "description-input-counter error-text" : "description-input-counter"}>{values.chapterResult.length}/1000</div>
                            <div className="chapter-drawer-footer" style={{
                                position: 'fixed',
                                bottom: 0,
                                right: 0,
                            }}>
                                <Button type="submit"  variant="contained">Сохранить</Button>
                            </div>

                        </Form>
                    )}
                </Formik>
            </div>
        </StyledDrawer>
    );
}
export default ChapterResultDrawer;
